export type AuthUser = {
  login: string;
  email: string | null;
  roles: string[];
  permissions: string[];
};

const ALLOWED_REGISTER_DOMAINS = ["bluecurrent.nl", "zubrtech.com"];
const EMAIL_RE = new RegExp(
  `^[^\\s@]+@(${ALLOWED_REGISTER_DOMAINS.map((d) => d.replace(/\./g, "\\.")).join("|")})$`,
  "i",
);

export function isAllowedRegisterEmail(email: string) {
  return EMAIL_RE.test(email.trim());
}

export function passwordOk(pw: string) {
  return pw.length >= 10 && /[A-Z]/.test(pw) && /[0-9]/.test(pw);
}

async function postJson<T>(url: string, body: unknown): Promise<{ res: Response; data: T }> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as T;
  return { res, data };
}

export async function fetchMe(): Promise<AuthUser | null> {
  const res = await fetch("/api/auth/me", { credentials: "same-origin" });
  if (!res.ok) return null;
  return res.json() as Promise<AuthUser>;
}

export async function login(login: string, password: string) {
  return postJson<{ error?: string; message?: string } & AuthUser>("/api/auth/login", {
    login,
    password,
  });
}

export async function logout() {
  return postJson<{ ok?: boolean }>("/api/auth/logout", {});
}

export async function register(email: string, password: string) {
  return postJson<{ error?: string; message?: string }>("/api/auth/register", {
    email,
    password,
  });
}

export async function forgotPassword(email: string) {
  return postJson<{ error?: string; message?: string }>("/api/auth/forgot-password", {
    email,
  });
}

export async function resendVerification(email: string) {
  return postJson<{ error?: string; message?: string }>("/api/auth/resend-verification", {
    email,
  });
}

export async function verifyEmail(token: string) {
  return postJson<{ error?: string; message?: string }>("/api/auth/verify-email", { token });
}

export async function resetPassword(token: string, password: string) {
  return postJson<{ error?: string; message?: string }>("/api/auth/reset-password", {
    token,
    password,
  });
}
